import has = Reflect.has;

export class PointOfSaleDto {

    name?:string;
    contact?:string;
    phone?:string;
    email?:string;
    zone?:string;
    destinationType?:string;
    destinationTypeValue?:string;
    address?:string;
    kms?:string;
    days?:any = {};
    hourFrom?:string;
    hourTo?:string;
    hasSecondTime?:boolean;
    hourFrom2?:string;
    hourTo2?:string;
    businessHours?:BusinessHoursDto[] = [];
    specialAttentionHours?:SpecialAttentionHoursDto[] = [];
    paymentMethods?:any = {};
    payInCash:boolean=false;
    street:string;
    locationName:string;
    locationOid:number;
    geoLocation:any={};
    shouldCall?:boolean=false;

    pickupIndications?:{
        meetingType:string,
        additionalInstructions?:"",
        phoneRequired?:string,
        phoneOptional?:string,
        miamiAirportPositions?:Array<string>,
        orlandoAirportPositions?: Array<{
            id?:number,
            terminal?:string,
            stop?:number,
            range?:{minValue:number,maxValue:number}}>,
        cancunAirportPositions?: {
            hasCounter?:boolean,
            counters?:Array<{
                counter:string,
                position:string}>}
    };
    public constructor(){}
}

export class BusinessHoursDto {
    dayOfWeek:string;
    openingHour:string;
    closingHour:string;
    additionalOpeningHour?:string;
    additionalClosingHour?:string;

    constructor(dayOfWeek:string,openingHour:string,closingHour:string,addOpeningHour:string=null,addClosingHour:string=null){
        this.dayOfWeek=dayOfWeek;
        this.openingHour=openingHour;
        this.closingHour=closingHour;
        this.additionalOpeningHour=addOpeningHour;
        this.additionalClosingHour=addClosingHour;
    }
}

export class SpecialAttentionHoursDto {
    constructor(public amount:string,public rangeFrom:string,public rangeTo:string){
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/point-of-sale-dto.ts